import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
import { UserService } from "../services/UserService";
import LabelMessage from './LabelMessage';
import "./ResetDevice.scss";
import { ReactComponent as LogoSVG } from "itd-common/assets/images/brand/logo.svg";
import Footer from './layout/Footer';
import SubmitButton from './controls/buttons/submitButton';
import Form from './containers/form';
import { UtilService } from '../services/UtilService';
import BrandLogo from '../components/layout/auth/authLogoModal';

interface IProps { }
let ResetDevice: React.FC<IProps> = () => {
    const T_PREFIX: string = 'pages.resetDevice.';
    const { t } = useTranslation();
    const [bgImage, setBgImage] = useState("/bgmerchantcenter.jpg");
            
    useEffect(() => {
        const updateBg = () => {
                setBgImage(window.innerWidth <= 425 ? "/bgmerchantcentermobile.jpg" : "/bgmerchantcenter.jpg");
            };
        updateBg();
        window.addEventListener("resize", updateBg);
        return () => window.removeEventListener("resize", updateBg);
    }, []);
    
    let resetDevice = (): void => {
        let token ="";
        if(window.location.href.indexOf("token=")>0){
            token = new URLSearchParams(window.location.href.substring(window.location.href.indexOf("token="))).get("token")+""
        }
        UserService.FinishResetDevices(token).then((response) => {
            if (response.status != 200) {
                Swal.fire({
                    title: t('errorOcurred'),
                    html: t("contactSupport"),
                    confirmButtonColor: '#f60',
                    timer: 6000,
                    timerProgressBar: true,
                    icon:"warning"
                });
            } else {
                Swal.fire({
                    title: t('DeviceReset'),
                    html: t("ReEntry"),
                    confirmButtonColor: '#f60',
                    icon:"success"
                }).finally(() => {
                    window.location.href = '/login'
                });
            }
        }).catch(() => {
            Swal.fire({
                title: t('errorOcurred'),
                html: t("contactSupport"),
                confirmButtonColor: '#f60',
                timer: 6000,
                timerProgressBar: true,
                icon:"warning"
            });
        });
    };
    
    return (
        <React.Fragment>
            <div className="page reset-key" style={{ backgroundImage: `url(${bgImage})`}}>
                <div className="container-login100">
                    <div className="lostphone-reset">
                        <div className="form">
                            <BrandLogo />
                            <div className="backward" />
                            <span className="login100-form-title pb-5">
                                {t(`${T_PREFIX}title`)}
                            </span>
                            <p>{t(`${T_PREFIX}description`)}</p>
                            <Form>
                                <>
                                    <div className="boton col-md-8">
                                        <div className="boton">
                                            <div className="boton__click">
                                                <SubmitButton onClick={resetDevice} className='btn btn-primary d-grid envio' label={t(`${T_PREFIX}unlink`)}></SubmitButton>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 d-flex justify-content-center ">
                                            <Link to={'/help-outside'} className="linkTo">
                                                {t(`${T_PREFIX}needHelp`)}
                                            </Link>
                                        </div>
                                    </div>
                                    </>
                                </Form>
                            </div>                      
                        </div>
                    </div>
                </div>
            <Footer isValid={false} />
        </React.Fragment>
    )
}
export default ResetDevice
